import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { Link, useParams } from "react-router-dom";
import parse from "html-react-parser";

import { checkIfSignedIn, getCustomPage } from "api";

import coverImage from "./cover2.jpg";
import styles from "./styles.module.css";

const CustomPage = () => {
  const { slug } = useParams();
  const [pageData, setPageData] = useState();
  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    const loadPage = async () => {
      const [customPageData, authCheck] = await Promise.all([
        getCustomPage(slug),
        checkIfSignedIn(),
      ]);
      setPageData(customPageData);
      setIsSignedIn(authCheck === true);
    };

    loadPage();
  }, [slug]);

  return (
    <div id="main-content-wrapper">
      <div id="hero-image">
        <img src={coverImage} width="100%" />
      </div>
      <div className={styles.content}>
        <div className={classnames("container", styles.container)}>
          <div className="row">
            <div className="col-md-3" />
            <div className="col-md-6">
              {isSignedIn && pageData?._id && (
                <p>
                  <Link
                    className="btn btn-default"
                    to={`/manage/pages/edit/${pageData._id}`}
                  >
                    Edit page
                  </Link>
                </p>
              )}
              {pageData?.content && parse(pageData.content)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomPage;
